import styled from 'styled-components';

export const FooterBottomSectionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 60px;
`;

export const FooterBottomSectionLeft = styled.div`
  display: flex;
  width: 100%;
`;

export const FooterBottomSectionRight = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;
